/**
 * HDS Delivery Picker for Shopify Plus Checkout - ENHANCED VERSION
 * 
 * Features:
 * - Date picker with button UI (shows day of week)
 * - Time window selector with radio buttons
 * - Matches My Muscle Chef design aesthetic
 * - Responsive mobile + desktop
 * 
 * Deploy to: staging-workoutmeals.myshopify.com (NOT production)
 */

(function() {
  'use strict';

  const CONFIG = {
    HDS_API: 'https://hds-delivery-admin-backend-production.up.railway.app',
    STORAGE_PREFIX: 'hds_',
    POLL_INTERVAL: 500,
    MAX_POLLS: 60,
    ENABLE_BACKEND_DATES: true,  // Use custom backend for date calculations
  };

  const STORAGE = {
    deliveryDate: `${CONFIG.STORAGE_PREFIX}delivery_date`,
    deliveryTime: `${CONFIG.STORAGE_PREFIX}delivery_time`,
    postcode: `${CONFIG.STORAGE_PREFIX}postcode`,
  };

  // ============= INIT =============
  
  console.log('[HDS Checkout Enhanced] Initializing...');

  let pollCount = 0;
  const addressPoll = setInterval(() => {
    const addressField = document.querySelector('[data-testid="address-line1"]');
    const postcodeField = document.querySelector('[data-testid="postcode"]');
    
    if (addressField || postcodeField) {
      clearInterval(addressPoll);
      console.log('[HDS Checkout Enhanced] Address fields detected');
      initializeDeliveryPicker();
    }
    
    pollCount++;
    if (pollCount > CONFIG.MAX_POLLS) {
      clearInterval(addressPoll);
      console.warn('[HDS Checkout Enhanced] Address fields not found after 30s');
    }
  }, CONFIG.POLL_INTERVAL);

  // ============= DELIVERY PICKER =============

  function initializeDeliveryPicker() {
    const pickerContainer = createEnhancedPickerUI();
    
    setTimeout(() => {
      const insertPoint = document.querySelector('[data-testid="payment-section"]') ||
                         document.querySelector('[data-testid="review-section"]') ||
                         document.querySelector('form');
      
      if (insertPoint) {
        insertPoint.parentNode.insertBefore(pickerContainer, insertPoint);
        console.log('[HDS Checkout Enhanced] UI injected');
        watchAddressChanges();
      }
    }, 1000);
  }

  function createEnhancedPickerUI() {
    const container = document.createElement('div');
    container.id = 'hds-delivery-picker';
    container.className = 'hds-enhanced-picker';
    
    container.innerHTML = `
      <div class="hds-container">
        <!-- Header -->
        <div class="hds-header">
          <h3 class="hds-title">📦 When can we deliver?</h3>
        </div>

        <!-- Date Selector -->
        <div class="hds-section">
          <label class="hds-section-label">Select Delivery Date</label>
          <div class="hds-dates-grid" id="hds-dates-grid">
            <div class="hds-loading">Loading available dates...</div>
          </div>
        </div>

        <!-- Time Selector -->
        <div class="hds-section" id="hds-time-section" style="display: none;">
          <label class="hds-section-label">Preferred Time Window</label>
          <div class="hds-time-options">
            <label class="hds-radio-item">
              <input type="radio" name="hds-time" value="AM" class="hds-radio-input">
              <span class="hds-radio-label">
                <span class="hds-time-label">Early Morning</span>
                <span class="hds-time-desc">6:00 AM - 7:00 AM</span>
              </span>
            </label>
            <label class="hds-radio-item">
              <input type="radio" name="hds-time" value="BUSINESS_HOURS" class="hds-radio-input" checked>
              <span class="hds-radio-label">
                <span class="hds-time-label">Business Hours</span>
                <span class="hds-time-desc">8:00 AM - 6:00 PM</span>
              </span>
            </label>
          </div>
        </div>

        <!-- Helper Text -->
        <div class="hds-helper-text">
          <p>🔥 Your meal will be freshly prepared and ready for cooking on your selected delivery day.</p>
        </div>

        <!-- Summary -->
        <div class="hds-summary" id="hds-summary" style="display: none;">
          <div class="hds-summary-content">
            <span class="hds-summary-icon">✅</span>
            <div>
              <p class="hds-summary-title">Delivery Scheduled</p>
              <p class="hds-summary-details" id="hds-summary-details"></p>
            </div>
          </div>
        </div>

        <!-- Error -->
        <div class="hds-error" id="hds-error" style="display: none;"></div>
      </div>

      <style>
        .hds-enhanced-picker {
          margin: 24px 0;
          padding: 0;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, sans-serif;
        }

        .hds-container {
          background: #f8f8f8;
          border: 1px solid #e5e5e5;
          border-radius: 8px;
          padding: 24px;
        }

        /* Header */
        .hds-header {
          margin-bottom: 24px;
          border-bottom: 2px solid #ff6b35;
          padding-bottom: 16px;
        }

        .hds-title {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #1a1a1a;
        }

        /* Sections */
        .hds-section {
          margin-bottom: 24px;
        }

        .hds-section-label {
          display: block;
          font-size: 14px;
          font-weight: 600;
          color: #333;
          margin-bottom: 12px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        /* Date Grid */
        .hds-dates-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
          gap: 10px;
        }

        .hds-loading {
          grid-column: 1 / -1;
          text-align: center;
          padding: 20px;
          color: #999;
          font-size: 14px;
        }

        .hds-date-button {
          padding: 12px 8px;
          border: 2px solid #ddd;
          border-radius: 6px;
          background: white;
          cursor: pointer;
          text-align: center;
          transition: all 0.2s ease;
          font-size: 13px;
          font-weight: 500;
        }

        .hds-date-button:hover {
          border-color: #ff6b35;
          background: #fff5f0;
        }

        .hds-date-button.active {
          background: #ff6b35;
          color: white;
          border-color: #ff6b35;
          box-shadow: 0 2px 8px rgba(255, 107, 53, 0.3);
        }

        .hds-date-day {
          display: block;
          font-size: 12px;
          color: #999;
          margin-bottom: 4px;
          text-transform: uppercase;
          letter-spacing: 0.3px;
        }

        .hds-date-date {
          display: block;
          font-size: 14px;
          font-weight: 600;
          color: inherit;
        }

        .hds-date-button.active .hds-date-day {
          color: rgba(255, 255, 255, 0.8);
        }

        /* Time Options */
        .hds-time-options {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .hds-radio-item {
          display: flex;
          align-items: flex-start;
          padding: 16px;
          border: 2px solid #ddd;
          border-radius: 6px;
          background: white;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .hds-radio-item:hover {
          border-color: #ff6b35;
          background: #fff5f0;
        }

        .hds-radio-input {
          margin-right: 12px;
          margin-top: 2px;
          cursor: pointer;
          accent-color: #ff6b35;
          width: 20px;
          height: 20px;
          flex-shrink: 0;
        }

        .hds-radio-label {
          display: flex;
          flex-direction: column;
          flex: 1;
        }

        .hds-time-label {
          font-weight: 500;
          color: #1a1a1a;
          font-size: 14px;
        }

        .hds-time-desc {
          font-size: 13px;
          color: #999;
          margin-top: 4px;
        }

        .hds-radio-item input:checked ~ .hds-radio-label .hds-time-label {
          color: #ff6b35;
          font-weight: 600;
        }

        /* Helper Text */
        .hds-helper-text {
          padding: 12px 16px;
          background: #fff5e6;
          border-left: 4px solid #ffa500;
          border-radius: 4px;
          margin-bottom: 16px;
        }

        .hds-helper-text p {
          margin: 0;
          font-size: 13px;
          color: #664d00;
          line-height: 1.5;
        }

        /* Summary */
        .hds-summary {
          padding: 16px;
          background: #e8f5e9;
          border-left: 4px solid #4caf50;
          border-radius: 6px;
          margin-bottom: 16px;
        }

        .hds-summary-content {
          display: flex;
          gap: 12px;
        }

        .hds-summary-icon {
          font-size: 20px;
          flex-shrink: 0;
        }

        .hds-summary-title {
          margin: 0;
          font-size: 14px;
          font-weight: 600;
          color: #2e7d32;
        }

        .hds-summary-details {
          margin: 4px 0 0 0;
          font-size: 13px;
          color: #558b2f;
        }

        /* Error */
        .hds-error {
          padding: 16px;
          background: #ffebee;
          border-left: 4px solid #f44336;
          border-radius: 6px;
          font-size: 13px;
          color: #c62828;
          margin-bottom: 16px;
        }

        /* Responsive */
        @media (max-width: 600px) {
          .hds-container {
            padding: 16px;
          }

          .hds-dates-grid {
            grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));
            gap: 8px;
          }

          .hds-date-button {
            padding: 10px 6px;
            font-size: 12px;
          }

          .hds-time-options {
            gap: 10px;
          }

          .hds-radio-item {
            padding: 12px;
          }
        }
      </style>
    `;

    // Attach event listeners
    container.addEventListener('change', (e) => {
      if (e.target.name === 'hds-time') {
        handleTimeChange(e.target.value, container);
      }
    });

    // Delegate date button clicks
    setTimeout(() => {
      container.addEventListener('click', (e) => {
        if (e.target.classList.contains('hds-date-button')) {
          const dateStr = e.target.dataset.date;
          handleDateChange(dateStr, container);
        }
      });
    }, 0);

    return container;
  }

  function handleDateChange(dateStr, container) {
    if (!dateStr) return;

    // Update storage
    sessionStorage.setItem(STORAGE.deliveryDate, dateStr);
    console.log(`[HDS Checkout Enhanced] Date selected: ${dateStr}`);

    // Update UI
    container.querySelectorAll('.hds-date-button').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.date === dateStr);
    });

    // Show time selector
    const timeSection = container.querySelector('#hds-time-section');
    if (timeSection) {
      timeSection.style.display = 'block';
    }

    updateSummary(container);
  }

  function handleTimeChange(timeValue, container) {
    sessionStorage.setItem(STORAGE.deliveryTime, timeValue);
    console.log(`[HDS Checkout Enhanced] Time selected: ${timeValue}`);
    updateSummary(container);
    attachDeliveryToCheckout(container);
  }

  function updateSummary(container) {
    const date = sessionStorage.getItem(STORAGE.deliveryDate);
    const time = sessionStorage.getItem(STORAGE.deliveryTime);

    if (date && time) {
      const summary = container.querySelector('#hds-summary');
      const details = container.querySelector('#hds-summary-details');

      const dateObj = new Date(date);
      const dayName = dateObj.toLocaleDateString('en-AU', { weekday: 'long' });
      const dateFormatted = dateObj.toLocaleDateString('en-AU', { month: 'short', day: 'numeric' });
      const timeLabel = time === 'AM' ? '6:00 AM - 7:00 AM' : '8:00 AM - 6:00 PM';

      details.textContent = `${dayName}, ${dateFormatted} - ${timeLabel}`;
      summary.style.display = 'block';

      console.log('[HDS Checkout Enhanced] Summary updated');
    }
  }

  function attachDeliveryToCheckout(container) {
    const date = sessionStorage.getItem(STORAGE.deliveryDate);
    const time = sessionStorage.getItem(STORAGE.deliveryTime);

    if (!date || !time) return;

    // Attach to hidden form fields so Shopify captures it
    let hiddenForm = document.querySelector('#hds-hidden-form');
    
    if (!hiddenForm) {
      hiddenForm = document.createElement('form');
      hiddenForm.id = 'hds-hidden-form';
      hiddenForm.style.display = 'none';
      container.parentNode.appendChild(hiddenForm);
    }

    // Update note attributes field
    const noteField = document.querySelector('[name="checkout[note]"]') ||
                     document.querySelector('[data-testid="note"]');
    
    if (noteField) {
      const noteText = `HDS-Delivery: ${date} @ ${time}`;
      noteField.value = noteText;
      console.log(`[HDS Checkout Enhanced] Attached to checkout note: ${noteText}`);
    }
  }

  function watchAddressChanges() {
    document.addEventListener('change', (e) => {
      const target = e.target;
      if (target.name && (target.name.includes('postcode') || target.name.includes('zip'))) {
        console.log('[HDS Checkout Enhanced] Address changed - refetching dates');
        setTimeout(() => {
          const postcode = extractPostcode();
          if (postcode) {
            fetchDeliveryDates(postcode);
          }
        }, 500);
      }
    });
  }

  function extractPostcode() {
    const inputs = [
      document.querySelector('[name="checkout[delivery_address][zip]"]'),
      document.querySelector('[name="checkout[delivery_address][postcode]"]'),
      document.querySelector('[data-testid="postcode"]'),
      document.querySelector('input[placeholder*="postcode" i]'),
      document.querySelector('input[placeholder*="zip" i]'),
    ];

    for (let input of inputs) {
      if (input && input.value) {
        return input.value.trim();
      }
    }
    return null;
  }

  function fetchDeliveryDates(postcode) {
    const url = `${CONFIG.HDS_API}/api/public/service-days?postcode=${encodeURIComponent(postcode)}&weeksToShow=4`;

    console.log(`[HDS Checkout Enhanced] Fetching dates for postcode: ${postcode}`);
    console.log(`[HDS Checkout Enhanced] URL: ${url}`);

    fetch(url)
      .then(res => res.json())
      .then(data => {
        console.log('[HDS Checkout Enhanced] API response:', data);
        if (data.serviceable && data.available_dates && data.available_dates.length > 0) {
          renderDateButtons(data.available_dates);
          sessionStorage.setItem(STORAGE.postcode, postcode);
        } else {
          showError('Delivery not available for this location yet.');
        }
      })
      .catch(err => {
        console.error('[HDS Checkout Enhanced] Fetch error:', err);
        showError('Unable to load delivery dates. Please try again.');
      });
  }

  function renderDateButtons(dates) {
    const grid = document.querySelector('#hds-dates-grid');
    if (!grid) return;

    grid.innerHTML = '';

    // HDS API already respects cutoff times — don't apply additional filters
    if (dates.length === 0) {
      grid.innerHTML = '<div class="hds-error">No available delivery dates. Please try again later.</div>';
      return;
    }

    dates.slice(0, 10).forEach(dateStr => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hds-date-button';
      btn.dataset.date = dateStr;

      const dateObj = new Date(dateStr);
      const dayName = dateObj.toLocaleDateString('en-AU', { weekday: 'short' });
      const dayNum = dateObj.getDate();

      btn.innerHTML = `<span class="hds-date-day">${dayName}</span><span class="hds-date-date">${dayNum}</span>`;

      grid.appendChild(btn);
    });

    console.log(`[HDS Checkout Enhanced] ${dates.length} dates available from HDS API`);
  }

  function showError(message) {
    const errorDiv = document.querySelector('#hds-error');
    if (errorDiv) {
      errorDiv.textContent = message;
      errorDiv.style.display = 'block';
    }
    console.error('[HDS Checkout Enhanced]', message);
  }

  // ============= INITIAL FETCH =============

  setTimeout(() => {
    const postcode = extractPostcode();
    if (postcode) {
      fetchDeliveryDates(postcode);
    }
  }, 2000);
})();
